import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../constants';

const useTableStyles = makeStyles((theme) => ({
    tableContainer: {
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden',
    },
    tableHeader: {
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
        '& .MuiTableRow-root': {
            '& .MuiTableCell-root:first-child': {
                borderTopLeftRadius: '12px',
            },
            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '12px',
            },
        },
    },
    tableHeaderCell: {
        color: '#FFFFFF',
        fontWeight: 500,
        fontSize: '13px',
        padding: theme.spacing(1, 1.5),
        borderBottom: 'none',
        letterSpacing: '0.2px',
        lineHeight: '1.3',
        height: '42px',
    },
    headerIcon: {
        marginRight: theme.spacing(0.6),
        fontSize: '14px',
        verticalAlign: 'middle',
        opacity: 0.9,
    },
    sortLabel: {
        color: '#FFFFFF !important',
        fontWeight: 500,
        fontSize: '13px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            color: '#FFFFFF !important',
            opacity: 0.95,
        },
        '&.MuiTableSortLabel-active': {
            color: '#FFFFFF !important',
            fontWeight: 600,
        },
        '& .MuiTableSortLabel-icon': {
            color: '#FFFFFF !important',
            opacity: 0.85,
            fontSize: '14px',
            marginLeft: '2px',
            marginTop: '0px',
        },
    },
    tableCell: {
        fontSize: '13px',
        padding: theme.spacing(1.2, 1.5),
        borderBottom: '1px solid #f0f0f0',
        color: '#424242',
    },
    tableRow: {
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
        '&:last-child .MuiTableCell-root': {
            borderBottom: 'none',
        },
        transition: 'background-color 0.15s ease',
    },
    searchContainer: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    tableTitle: {
        fontWeight: 700,
        fontSize: '18px',
        color: theme.palette.primary.main,
    },
    searchInput: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        width: '320px',
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            height: '40px',
            fontSize: '14px',
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
            fontSize: '14px',
        },
        '& .MuiInputAdornment-root': {
            marginRight: '4px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d0d0d0',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
        },
    },
    tablePagination: {
        '& .MuiTablePagination-caption': {
            color: theme.palette.primary.main,
        },
        '& .MuiIconButton-root': {
            color: theme.palette.primary.main,
        },
    },
    participationHigh: {
        color: COLORS.participationHigh,
        fontWeight: 'bold',
    },
    participationMedium: {
        color: COLORS.participationMedium,
        fontWeight: 'bold',
    },
    participationLow: {
        color: COLORS.participationLow,
        fontWeight: 'bold',
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
    },
}));

export default useTableStyles;
